import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deduction-details-grid',
  templateUrl: './deduction-details-grid.component.html',
  styleUrls: ['./deduction-details-grid.component.css']
})
export class DeductionDetailsGridComponent implements OnInit {

  title="View Deduction Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/deduction-details/deduction-details-grid/deduction-details-grid.component.ts